import React from 'react';
import javiFisio from '../images/Image (13).jpg';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FaUserMd, 
  FaGraduationCap, 
  FaHeart, 
  FaCertificate,
  FaArrowRight,
  FaWhatsapp
} from 'react-icons/fa';
import './About.css';

const About = () => {
  const qualifications = [
    {
      icon: <FaGraduationCap />,
      title: "Grado en Fisioterapia",
      description: "En la Universidad Francisco de Vitoria"
    },
    {
      icon: <FaCertificate />,
      title: "Curso Punción Seca",
      description: "En el Síndrome del dolor Miofascial"
    },
    {
      icon: <FaCertificate />,
      title: "Curso ENA",
      description: "Curso de Electroneuroacupuntura en el INEFI"
    }
  ];

  const values = [
    {
      icon: <FaHeart />,
      title: "Atención Personalizada",
      description: "Cada paciente es único. Desarrollo tratamientos específicos adaptados a tus necesidades individuales."
    },
    {
      icon: <FaUserMd />,
      title: "Profesionalidad",
      description: "Más de 3 años de experiencia en fisioterapia, siempre actualizado con las últimas técnicas."
    },
    {
      icon: <FaHeart />,
      title: "Compromiso",
      description: "Tu recuperación es mi prioridad. Trabajamos juntos para lograr los mejores resultados."
    }
  ];

  return (
    <div className="about">
      {/* Story Section */}
      <section className="story section">
        <div className="container">
          <div className="story-content">
            <motion.div 
              className="story-text"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2>Mi Historia</h2>
              <p>
                Mi pasión por la fisioterapia comenzó hace años, cuando decidí 
                dedicar mi vida a ayudar a las personas a recuperar su movilidad y calidad de vida.
              </p>
              <p>
                A lo largo de mi carrera, he tenido el privilegio de trabajar con pacientes 
                de todas las edades y condiciones, desde deportistas de élite hasta personas 
                que buscan mejorar su bienestar diario.
              </p>
              <p>
                Mi enfoque se basa en la atención integral, combinando técnicas tradicionales 
                con las últimas innovaciones en fisioterapia para ofrecer tratamientos efectivos 
                y personalizados.
              </p>
            </motion.div>
            <motion.div 
              className="story-image"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img src={javiFisio} alt="Javi Fisio trabajando" className="story-img" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Qualifications Section */}
      <section className="qualifications section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Formación y Certificaciones</h2>
            <p>Mi formación continua me permite ofrecer los mejores tratamientos</p>
          </motion.div>
          
          <div className="qualifications-grid">
            {qualifications.map((qualification, index) => (
              <motion.div 
                key={index}
                className="qualification-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="qualification-icon">
                  {qualification.icon}
                </div>
                <h3>{qualification.title}</h3>
                <p>{qualification.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Mi Filosofía de Trabajo</h2>
            <p>Los valores que guían mi práctica profesional</p>
          </motion.div>
          
          <div className="values-grid">
            {values.map((value, index) => (
              <motion.div 
                key={index}
                className="value-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="value-icon">
                  {value.icon}
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta section">
        <div className="container">
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>¿Listo para empezar tu recuperación?</h2>
            <p>
              Conoce más sobre mis servicios y cómo puedo ayudarte a mejorar tu calidad de vida.
            </p>
            <div className="cta-buttons">
              <a href="/servicios" className="btn btn-primary">
                Ver Servicios
                <FaArrowRight />
              </a>
              <a href="https://wa.me/34654384937" className="btn btn-secondary">
                <FaWhatsapp />
                Consultar por WhatsApp
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About; 